export var OrderConfirmModalTestIds = {
    modal: "orderConfirmModal",
    deliveryConfirmation: "deliveryConfirmation",
};
